import { useSearch } from '@/hooks/use-search';

export const useGlobalSearch = () => {
	const { searchQuery, setSearchQuery, isSearchVisible, setIsSearchVisible } = useSearch();

	const openSearch = () => {
		setIsSearchVisible(true);
	};

	const closeSearch = () => {
		setIsSearchVisible(false);
	};

	const search = (query: string) => {
		setSearchQuery(query);
		setIsSearchVisible(true);
	};

	return {
		searchQuery,
		setSearchQuery,
		isSearchVisible,
		openSearch,
		closeSearch,
		search,
	};
};
